import React from 'react';
export function ProofSection() {
  return <section className="bg-off-white py-20 px-4" data-id="element-150">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-151">
        <h2 className="text-3xl md:text-4xl text-near-black" data-id="element-152">
          Lo que cambia en 72 horas
        </h2>
        <p className="text-xl font-serif text-dark-green leading-relaxed italic" data-id="element-153">
          "Notarás que el reloj te queda más suelto, que la presión en la
          cintura desaparece y que la 'niebla mental' se disipa."
        </p>
        <p className="text-lg font-sans text-gray-700 leading-relaxed" data-id="element-154">
          No es magia, es bioquímica aplicada para pasar de un estado de
          supervivencia a uno de recuperación.
        </p>
      </div>
    </section>;
}